/* eslint-disable no-lone-blocks */
import React from 'react';
import { Guardian } from '@xaamin/guardian';
import { ProgressBar } from 'react-bootstrap';

import useGlobal from '../../../../../store';
import { FormControl } from '../../../../../facturotopia';
import { TheError } from '../../../../../shared/responses/TheResult';

const mapState = (store) => {
  return store.modulo.timbrado_masivo.upload;
};

const mapActions = (actions) => {
  return { ...actions.modulo.timbrado_masivo.upload };
};

const TimbradoMasivoUploadForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data, progress, busy, error } = state;

  const select = (event) => {
    actions.onChange({
      file: event.target.files[0],
    });
  };

  const handleOnChange = (values) => {
    actions.onChange(values);
  };

  /* COMMENT la versión 3.3 ya no es vigente, descomentar y cambiar para hacer fallback a futuras versiones */
  // const handleOnFallbackChange = (event) => {
  //   const { name, checked } = event.target;

  //   actions.onChange({
  //     [name]: checked,
  //   });
  // };

  const getOptions = () => {
    let options = [
      {
        label: 'Tipo de archivo',
        value: '',
      },
    ];

    {
      (Guardian.allows('factura.crear.ingreso') ||
        Guardian.allows('factura.crear.egreso') ||
        Guardian.allows('factura.crear.traslado')) &&
        options.push({ label: 'Ingreso / Egreso', value: 'timbrado-comprobantes' });
    }
    {
      Guardian.allows('factura.crear.nomina') && options.push({ label: 'Nómina', value: 'timbrado-nomina' });
    }
    {
      Guardian.allows('factura.crear.pago') && options.push({ label: 'Pagos', value: 'timbrado-pagos' });
    }

    return options;
  };

  return (
    <>
      {!!error && <TheError error={error} />}

      <FormControl
        type="select"
        label="Tipo de archivo"
        name="tipo"
        placeholder=""
        help=""
        value={data.tipo}
        options={getOptions()}
        onChange={handleOnChange}
      />

      {/* COMMENT la versión 3.3 ya no es vigente, descomentar y cambiar para hacer fallback a futuras versiones */}
      {/* {data.tipo === 'timbrado-nomina' && (
        <Row className="z-index-top">
          <Col>
            <Form.Group controlId="fallback">
              <Form.Check
                type="checkbox"
                custom={true}
                name="fallback"
                label="Emitir como CFDI 3.3 si falla la emisión de CFDI 4.0 (Fallback)"
                checked={data.fallback || false}
                onChange={handleOnFallbackChange}
              />
            </Form.Group>
          </Col>
        </Row>
      )} */}

      <label>
        <input
          type="file"
          accept=".csv, .txt, .xls, .xlsx"
          onChange={select}
        />
      </label>

      <div className="p-3">
        <label>Instrucciones.</label>
        <ul className="list-unstyled">
          {/* <li>1. Descarga el <a target="_blank" href="/resources/template_ingreso_egreso.xlsx">template</a></li>
          <li>2. Sigue la <a target="_blank" href="/resources/guia_de_llenado_excel.pdf">guía de llenado</a></li> */}
          <li>1. Descarga el template</li>
          <li>2. Sigue la guía de llenado</li>
          <li>3. Sube el archivo</li>
        </ul>
      </div>

      {(busy || progress > 0) && !!data.file && (
        <ProgressBar
          striped
          variant="info"
          label={`${progress}%`}
          now={progress}
        />
      )}
    </>
  );
};

export default TimbradoMasivoUploadForm;
